import fp from 'lodash/fp';
import { configurations } from './configurations';
import { apiAction as getById } from './configurations/getById';
import { apiAction as loadMore } from './configurations/loadMore';
import { apiAction as rateContent } from './configurations/rateContent';

export const apiActions = {
  content: {
    getById,
    loadMore,
    rateContent
  }
}

const actions = {
  content: {
    api: {
      ...fp.reduce(
        (prev, { name, action: { content: { api } } }) => ({
          ...prev,
          [name]: api[name]
        }),
        {}
      )(configurations)
    },
    ...fp.reduce(
      (prev, { name, action: { content } }) => ({
        ...prev,
        [name]: content[name]
      }),
      {}
    )(configurations)
  }
};

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/content/actions.js